import $ from "jquery";
import * as d3 from "d3";
import moment from "moment";

export function getPosition(el) {
    let xPos = 0;
    let yPos = 0;

    while (el) {
        if (el.tagName === "BODY") {
            // deal with browser quirks with body/window/document and page scroll
            let xScroll = el.scrollLeft || document.documentElement.scrollLeft;
            let yScroll = el.scrollTop || document.documentElement.scrollTop;

            xPos += el.offsetLeft - xScroll + el.clientLeft;
            yPos += el.offsetTop - yScroll + el.clientTop;
        } else {
            // for all other non-BODY elements
            xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
            yPos += el.offsetTop - el.scrollTop + el.clientTop;
        }

        el = el.offsetParent;
    }
    return {
        x: xPos,
        y: yPos
    };
}

export function scrollTop() {
    $("html, body").scrollTop({ top: 0 });
}

export function chunkArray(data, chunk_size) {
    let index = 0;
    let arrayLength = data && data.length;
    let tempArray = [];

    for (index = 0; index < arrayLength; index += chunk_size) {
        let myChunk = data && data.slice(index, index + chunk_size);
        // Do something if you want with the group
        tempArray.push(myChunk);
    }

    return tempArray;
}

export function camelize(str) {
    str = str && str.toLowerCase();
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
            return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
        })
        .replace(/\s+/g, "");
}

export function kbtomb(kb) {
    let d = kb && kb.split(" ");
    kb = d[0];
    kb = kb / 1000;
    return Math.round(kb * 100) / 100;
}

export function sliceTo(data, length = 50) {
    let splited = data && data.slice(0, length);
    return data && data.length > length ? splited + " ..." : splited;
}

export function renameKeys(obj, newKeys) {
    const keyValues =
        obj &&
        Object.keys(obj).map(key => {
            const newKey = newKeys[key] || key;
            return { [newKey]: obj[key] };
        });
    return Object.assign({}, ...keyValues);
}

export function calculateTranslateAndScale(allBounds, width, height) {
    let bound0 = d3.min(allBounds, d => d[0][0]);
    let bound1 = d3.min(allBounds, d => d[0][1]);
    let bound2 = d3.max(allBounds, d => d[1][0]);
    let bound3 = d3.max(allBounds, d => d[1][1]);
    let dx = bound2 - bound0,
        dy = bound3 - bound1,
        x = (bound0 + bound2) / 2,
        y = (bound1 + bound3) / 2,
        scale = 0.9 / Math.max(dx / width, dy / height),
        translate = [width / 2 - scale * x, height / 2 - scale * y];
    return { scale, translate };
}

export function customCollapse() {
    $(".xs-collapse-wrapper .burger a").on("click", function (e) {
        e.preventDefault();
        if ($(".xs-collapse-wrapper .burger a i").hasClass("fa-bars")) {
            $(".xs-collapse-wrapper .burger a i")
                .removeClass("fa-bars")
                .addClass("fa-times");
        } else {
            $(".xs-collapse-wrapper .burger a i")
                .addClass("fa-bars")
                .removeClass("fa-times");
        }
        $(".xs-collapse").toggleClass("in");
    });

    $(".nav-tabs")
        .find("a")
        .on("click", function (e) {
            e.preventDefault();
            let parent = $(this).data("parent");
            if (parent !== "#accordion") {
                $(".xs-collapse").toggleClass("in");
            }
        });
}

export function containsObject(obj, list) {
    let i;
    for (i = 0; i < list.length; i++) {
        if (list[i] === obj) {
            return true;
        }
    }

    return false;
}

export function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function countDuplicate(arr) {
    let item = [];
    arr &&
        arr.forEach(function (i) {
            item[i] = (item[i] || 0) + 1;
        });
    let data = [];
    for (let obj in item) {
        let items = {
            label: obj,
            value: item[obj]
        };
        data.push(items);
    }
    return data;
}

export function isToday(date) {
    return moment(date).format("l") === moment().format("l");
}

export function json2CSV({
    data = null,
    columnDelimiter = ",",
    lineDelimiter = "\n"
}) {
    let result, ctr, keys;

    if (data === null || !data.length) {
        return null;
    }

    keys = Object.keys(data[0]);

    result = "";
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(item => {
        ctr = 0;
        keys.forEach(key => {
            if (ctr > 0) {
                result += columnDelimiter;
            }

            result +=
                typeof item[key] === "string" && item[key].includes(columnDelimiter)
                    ? `"${item[key]}"`
                    : item[key];
            ctr++;
        });
        result += lineDelimiter;
    });

    return result;
}

export function removeOtherActive() {
    let topNav = document.querySelector("#topNav");
    let links = topNav.querySelectorAll("li>a");
    links.forEach(a => {
        a.addEventListener("click", function handleClick(e) {
            links.forEach(e => e.classList.remove("active"));
            e.target.classList.add("active");
        });
    });
}

export function getSettingValue(key, settings) {
    if (settings && settings.data) {
        let data = settings.data.filter(d => d[key]);
        return data.length > 0 ? data[0][key] : null;
    }
    return null;
}

export const requiredCols = [
    "Partner Organization",
    "Partner Organization ",
    "Funding Organisation",
    "District",
    "GaunPalika",
    "Municipality",
    "GaPaNa_Name",
    "GaPaNa_Ward",
    // "GaNaPa Ward Number",
    "VDC to Palika",
    "VDC (ward) to Palika",
    "Ward",
    "Sector",
    "Activity Type",
    "Activity Status",
    "Unit (Indicator)",
    "Unit",
    "Total Planned",
    "Total Reached",
    "Planned#",
    "Reached#"
];

export function downloadArrayToCSV(rows, filename = "data.csv") {
    let csvContent = "data:text/csv;charset=utf-8,";
    if (rows && rows.length > 0) {
        let columns = Object.keys(rows[0]);
        csvContent += columns.join(",") + "\n";
        rows.forEach(function (rowArray) {
            let resultContent = "";
            columns.forEach(function (col) {
                resultContent += rowArray[col];
            });
            csvContent += resultContent;
        });

        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", filename);
        link.click();
        // window.open(encodedUri);
    }
}

export function getColorData(data, districts) {
    let gapanaCode = d3.map(data, d => d["GaPaN_Ward_Code"]).keys();
    let required = {};
    let length = [];

    gapanaCode = gapanaCode.filter(d => {
        if (d == "#N/A") {
            return false;
        } else if (d == "") {
            return false;
        }
        return true;
    });

    gapanaCode &&
        gapanaCode.forEach(m => {
            let a = data.filter(d => d["GaPaN_Ward_Code"] == m);
            required = { ...required, [m]: a };
            length = [...length, a.length];
        });
    required = { ...required, length };
    return required;
};

export function getColor(value, dist) {
    value = parseInt(value);
    if (dist) {
        value = value === 0 ? 0 : Math.ceil(value / 7.79);
    }
    if (value === 0) {
        return "#e1e1e1";
    } else if (value > 0 && value <= 3) {
        return "#bee8ff";
    } else if (value > 3 && value <= 7) {
        return "#6ccfea";
    } else if (value > 7 && value <= 10) {
        return "#3baecc";
    } else if (value > 10 && value <= 13) {
        return "#3e80ce";
    } else {
        return null;
    }
}

export function getDistrictColor(value) {
    value = parseInt(value);
    if (value === 0) {
        return "#e1e1e1";
    } else if (value > 0 && value <= 3) {
        return "#bee8ff";
    } else if (value > 3 && value <= 7) {
        return "#6ccfea";
    } else if (value > 7 && value <= 10) {
        return "#3baecc";
    } else if (value > 10 && value <= 20) {
        return "#3e80ce";
    }
    return "#2b4aaf";
}

export function getPalikaColor(value) {
    value = parseInt(value);
    if (value >= 0 && value <= 20) {
        return "#edf8fb";
    } else if (value > 20 && value <= 40) {
        return "#b2e2e2";
    } else if (value > 40 && value <= 60) {
        return "#66c2a4";
    } else if (value > 60 && value <= 80) {
        return "#2ca25f";
    } else if (value > 80 && value <= 100) {
        return "#006d2c";
    }

    return "#edf8fb";
}

export const colorRange = [
    { min: 0 },
    { min: 1, max: 3 },
    { min: 4, max: 7 },
    { min: 8, max: 10 },
    { min: 11, max: 'more' }
];

export const districtColorRange = [
    { min: 0 },
    { min: 1, max: 3 },
    { min: 4, max: 7 },
    { min: 8, max: 10 },
    { min: 11, max: 20 },
    { min: 21, max: 'more' }
];

export const palikaColorRange = [
    { min: 0, max: 20 },
    { min: 21, max: 40 },
    { min: 41, max: 60 },
    { min: 61, max: 80 },
    { min: 81, max: 100 }
];

export function capitalize(str) {
    if (str) {
        // let resultString = "";
        // let strArray = str.split(" ");
        // if(strArray && Array.isArray(strArray) && strArray.length > 0){
        //   strArray.map( (d,i) => {
        //     if(i+1 !== strArray.length){
        //       resultString += d.charAt(0).toUpperCase() + d.slice(1).toLowerCase() + " ";
        //     }  else  {
        //       resultString += d.charAt(0).toUpperCase() + d.slice(1).toLowerCase();
        //     }
        //   });
        //   return resultString;
        // }
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
}

export function getLegendData(data) {
    let res = {};
    let status = data.map(d => d["Activity Status"]).filter(d => d !== "");
    status = countDuplicate(status);
    let sts = {};
    status &&
        status.forEach(d => {
            sts = { ...sts, [d.label]: d.value };
        });

    let po = d3.map(data, d => d["Partner Organization"]).keys();
    let WardNum = data[0]["GaNaPa Ward Number"];
    // po = countDuplicate(po);
    res = { ...sts, po, WardNum };
    return res;
}

export function getTooltipData({ csvData, gapanaCode }) {
    if (csvData && csvData.length > 0 && gapanaCode && gapanaCode.length > 0) {
        let filteredData = csvData.filter(d => d['GaPaN_Ward_Code'] == gapanaCode);
        let poCount = d3.map(filteredData, d => d['Partner Organization'] || d['Partner Organization']).keys().length || 0;
        let totalPlanned = filteredData.filter(d => d['Activity Status'] == 'Planned').length || 0;
        let totalOngoing = filteredData.filter(d => d['Activity Status'] == 'Ongoing').length || 0;
        let totalCompleted = filteredData.filter(d => d['Activity Status'] == 'Completed').length || 0;
        return {
            poCount,
            totalPlanned,
            totalOngoing,
            totalCompleted,
        }
    }
    return {};
}

export function getBarData(data) {
    let orgs;
    orgs = d3
        .map(data, d => d["Partner Organization"] || d["Partner Organization "])
        .keys();
    return orgs
        .map(function (o) {
            let reducedData = {};
            let completed = data.filter(
                d =>
                    (d["Partner Organization"] || d["Partner Organization "]) === o &&
                    d["Activity Status"] === "Completed"
            );
            let ongoing = data.filter(
                d =>
                    (d["Partner Organization"] || d["Partner Organization "]) === o &&
                    d["Activity Status"] === "Ongoing"
            );
            let planned = data.filter(
                d =>
                    (d["Partner Organization"] || d["Partner Organization "]) === o &&
                    d["Activity Status"] === "Planned"
            );
            reducedData.Completed = completed.length;
            reducedData.Ongoing = ongoing.length;
            reducedData.Planned = planned.length;
            reducedData.orgName = o;
            return reducedData;
        })
        .sort((a, b) => (b.Completed + b.Ongoing + b.Planned) - (a.Completed + a.Ongoing + a.Planned));
}

export function getPieData(data) {
    let pieData =
        data &&
        data.map(d => d["Partner Organization"] || d["Partner Organization "]);
    return countDuplicate(pieData);
}

export function getDataForReactSelect(data) {
    if (data && data.length > 0) {
        let dis = data && d3.map(data, d => capitalize(d["District"])).keys().sort();
        let pos = data && d3.map(data, d => d["Partner Organization"] || d["Partner Organization "]).keys().sort();
        let ats = data && d3.map(data, d => d["Activity Type"]).keys().sort();
        let ga = data && d3.map(data, d => d["Municipality"]).keys().sort();
        let se = data && d3.map(data, d => d["Sector"]).keys().sort();

        let districts = dis && dis.reduce((acc, item) => acc.concat({ label: item, value: item }), []) || [];
        let partnerOrganizations = pos && pos.reduce((acc, item) => acc.concat({
            label: item,
            value: item
        }), []) || [];
        let activityTypes = ats && ats.reduce((acc, item) => acc.concat({
            label: item,
            value: item
        }), []) || [];
        let gapanas = ga && ga.reduce((acc, item) => acc.concat({ label: item, value: item }), []) || [];
        let sectors = se && se.reduce((acc, item) => acc.concat({ label: item, value: item }), []) || [];
        return {
            districts,
            partnerOrganizations,
            activityTypes,
            gapanas,
            sectors
        };
    }
    return {};
}

export function makeReactSelectSelectedValues(selectedDistricts) {
    return selectedDistricts && selectedDistricts.reduce((acc, item) => acc.concat({
        label: item,
        value: item
    }), []) || [];
}

export function getCsvFilename({
    districtName,
    selectedDistricts,
    selectedGapanas,
    selectedPos,
    selectedSectors,
    selectedActivityStatus
}) {
    let filename = '';
    if (districtName && districtName.length > 0) {
        filename += `${districtName}_`;
    }
    if (selectedDistricts && selectedDistricts.length > 0) {
        filename += selectedDistricts && `${selectedDistricts.join('_')}_` || ''
    }
    if (selectedGapanas && selectedGapanas.length > 0) {
        filename += selectedGapanas && `${selectedGapanas.join('_')}_` || ''
    }
    if (selectedPos && selectedPos.length > 0) {
        filename += selectedPos && `${selectedPos.join('_')}_` || ''
    }
    if (selectedSectors && selectedSectors.length > 0) {
        filename += selectedSectors && `${selectedSectors.join('_')}_` || ''
    }
    if (selectedActivityStatus && selectedActivityStatus.length > 0) {
        filename += selectedActivityStatus && selectedActivityStatus.join('_') || ''
    }
    filename = filename && filename.split(' ').join('_') || 'data'
    filename = filename && filename.slice(0, 50)
    return `${filename}.csv`;
}
